<div class="page-layout carded fullwidth" >
  <mat-drawer-container class="overlay-container page-layout carded fullwidth" >

    <filtros-kri [(filtro)]="filterForm" (loadData)="getElements(0)" (filterChange)="filterForm=$event"></filtros-kri>


    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{titulo}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR
            <div class="toolbar px-24 py-8">
                <span>KRI</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24">


                <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8">

                  <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                  <!-- User Column -->

                  <ng-container matColumnDef="activo">
                    <th mat-header-cell *matHeaderCellDef> Activo </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-icon  aria-hidden="false" aria-label="print" *ngIf="element.tieneEditar==null || !element.tieneEditar">cancel</mat-icon>
                      <mat-icon  aria-hidden="false" aria-label="print" *ngIf="element.tieneEditar" >check</mat-icon>
                      <mat-icon  aria-hidden="false" aria-label="print" *ngIf="element.tieneEditar && element.estaAtrasado" >warning_amber</mat-icon></td>
                  </ng-container>

                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef> Nombre </th>
                    <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                  </ng-container>

                  <!-- Role Column
                  <ng-container matColumnDef="tipo-evaluacion">
                    <th mat-header-cell *matHeaderCellDef> Tipo de evaluacion. </th>
                    <td mat-cell *matCellDef="let element"> {{element.tipoEvaluacion?.nombre}} </td>
                  </ng-container>
                  -->

                  <ng-container matColumnDef="evaluacion">
                    <th mat-header-cell *matHeaderCellDef> Evaluación </th>
                    <td mat-cell *matCellDef="let element"> {{element.evaluacion?.nombre}} (Versión {{element.evaluacion?.version}})</td>
                  </ng-container>

                  <ng-container matColumnDef="evaluacionActiva">
                    <th mat-header-cell *matHeaderCellDef> Evaluación Estado </th>
                    <td mat-cell *matCellDef="let element"> {{element.evaluacion?.estado}} </td>
                  </ng-container>

                  <ng-container matColumnDef="riesgo">
                    <th mat-header-cell *matHeaderCellDef> Riesgo</th>
                    <td mat-cell *matCellDef="let element"> {{element.riesgo?.nombre}} </td>
                  </ng-container>

                  <ng-container matColumnDef="frecuencia">
                    <th mat-header-cell *matHeaderCellDef> Frecuencia</th>
                    <td mat-cell *matCellDef="let element"> {{element.frecuencia}} </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Acción </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                      <a (click)="openDialog('View',element)">Ver</a>
                      <span *ngIf="element.tieneEditar"> | </span>
                      <a (click)="openDialog('Carga',element)" *ngIf="element.tieneEditar">Cargar</a>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator #paginator [length]="elementCount" [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="basicSlice"
            (page)="OnePageChange($event)" showFirstLastButtons></mat-paginator>


            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

      </div>
      <!-- / CENTER -->
  </mat-drawer-container>
</div>
